// extracted by mini-css-extract-plugin
module.exports = {"modal":"ui_modal__2IszF","container":"ui_container__1Dq0a","scrollable":"ui_scrollable__2ho6A"};